import DepsService from 'services/dependencies';

const CONTEXT = 'dashboard';

export const fetchGamesComing = () => {
  const { url } = DepsService.rest.widgets.instant.gamesComing;
  const queryParams = {};
  const urlParams = {};
  const path = 'widgets.instant.gamesComing';

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams, path);
};

export const fetchGamesLaunched = () => {
  const { url } = DepsService.rest.widgets.instant.gamesLaunched;
  const queryParams = {};
  const urlParams = {};
  const path = 'widgets.instant.gamesLaunched';

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams, path);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/new-games.api.js